import axios from "axios";
import { endpoints } from "../_config";
import { getUserTokenFromStorage } from "../_config/helper.config";

class CustomSubdomainService {
  /**
   * Get custom subdomains list
   * @param {User} user
   */
  static async getAllRequests(communityId) {
    return axios
      .get(endpoints.customSubdomain.getAllRequests(communityId), {
        headers: {
          Authorization: "Bearer " + getUserTokenFromStorage(),
        },
      })
      .then((response) => response.data);
  }
  /**
   * Create subdomain request
   * @param {User} user
   */
  static async createRequest(communityId, customDomain) {
    return axios
      .post(
        endpoints.customSubdomain.createRequest(communityId),
        {
          customDomain,
        },
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }
  /**
   * Delete subdomain request
   * @param {User} user
   */
  static async deleteRequest(communityId, requestId) {
    return axios
      .delete(endpoints.customSubdomain.deleteRequest(communityId, requestId), {
        headers: {
          Authorization: "Bearer " + getUserTokenFromStorage(),
        },
      })
      .then((response) => response.data);
  }
}

export { CustomSubdomainService };
